import React from "react";

const ContractConfirmation = () =>
  <div className="contractConfirmation">
    <h2>Thank you for your submission!</h2>
    <hr />
    <h2>A Go4 Account Representative will get back to you within 24 hours.</h2>
  </div>

export default ContractConfirmation
